import '../../styles/Search.css';

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from '@tanstack/react-query';
import { setBackgroundImage } from "../../helpers/helpers";

import Loader from "../../components/Loader";
import MediaList from "../../components/MediaList";

const SEARCH_TIMEOUT = 1000;

const fetchMovies = async (query: string) => {
    if (!query) return { results: [] };
    
    const apiKey = process.env.REACT_APP_TMDB_API_KEY;
    const response = await fetch(`https://api.themoviedb.org/3/search/multi?query=${query}&include_adult=false&language=en-US`, {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${apiKey}`,
        }
    });
    
    return await response.json();
};

const Search = () => {
    setBackgroundImage('');
    const navigate = useNavigate();
    const query = new URLSearchParams(window.location.search).get("query") || "";
    const [searchInput, setSearchInput] = useState(query);

    const { data: movieData, isLoading, error } = useQuery({
        queryKey: ['movies', query],
        queryFn: () => fetchMovies(query),
        enabled: !!query, // Only run query if query exists
        staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    });

    const movies = movieData?.results || [];

    useEffect(() => {
        setSearchInput(query);
    }, [query]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const trimmed = searchInput.trim();
            if (trimmed && trimmed !== query) {
                navigate(`/search?query=${trimmed}`);
            } else if (!trimmed && query) {
                navigate('/search');
            }
        }, SEARCH_TIMEOUT);

        return () => clearTimeout(timeoutId);
    }, [searchInput, query, navigate]);

    if (error) {
        return (
            <div className="search">
                <p>Error loading movies: {error.message}</p>
            </div>
        );
    }

    document.title = query ? `Search: ${query}` : 'Search Movies';

    return (
        <div className="search">
            {isLoading ? (
                <Loader fullscreen message="Loading Movies..." />
            ) : (
                <div className="search-results">
                    <h1 className="search-results-title">Showing search results for: <span className="search-query">{query}</span></h1>
                    <MediaList media={movies} />
                </div>
            )}
        </div>
    )
}

export default Search;